define('presentation/common/routeToModal/facades/routeToLiveReceptionistScriptFacade',['common/promises/promiseFactory',
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
    'presentation/common/routeToModal/presentationObjects/liveReceptionistScriptPresentationObject',
], function() {

    const LiveReceptionistScriptPresentationObjectConstructor = require('presentation/common/routeToModal/presentationObjects/liveReceptionistScriptPresentationObject');
    const liveReceptionistScriptSocket = require('externalDependencies/clientWebSocket').forApplication("liveReceptionistScript");
    const _commonState = require('common/storage/commonState');

    let _promiseFactory = null;

    const _getLiveReceptionistScripts = () => {
        return _promiseFactory.defer((promise) => {
            liveReceptionistScriptSocket.send("retrieveAll", {}, (liveReceptionistScripts) => {
                const scripts = liveReceptionistScripts.map((liveReceptionistScript) => {
                    const { liveReceptionistScriptId, name, status, type } = liveReceptionistScript;
                    return {
                        id: liveReceptionistScriptId,
                        name: name,
                        status: status,
                        scriptType: type,
                        type: _commonState.types.liveReceptionistScript
                    };
                });
                promise.resolve(scripts);
            });
        });
    };

    const _getLiveReceptionistScriptById = (liveReceptionistScriptId) => {
        return _promiseFactory.defer((promise) => {
            const parameters = {
                "liveReceptionistScriptId": liveReceptionistScriptId
            };
            liveReceptionistScriptSocket.send("getLiveReceptionistScript", parameters, (liveReceptionistScript) => {
                const { liveReceptionistScriptId, name, status, type } = liveReceptionistScript;
                const script = {
                        id: liveReceptionistScriptId,
                        name: name,
                        status: status,
                        scriptType: type,
                        type: _commonState.types.liveReceptionistScript
                };
                promise.resolve(script);
            });
        });
    };

    const _dispose = () => {
        liveReceptionistScriptSocket.disposeOfEvents();
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        let self = this;

        self.init = _init;
        self.getLiveReceptionistScripts = _getLiveReceptionistScripts;
        self.getLiveReceptionistScriptById = _getLiveReceptionistScriptById;
        self.dispose = _dispose;
    };
});

